import { Action, createReducer, on } from '@ngrx/store'
import { ActivityState, initialActivityState } from '../state/activity.state'
import {
  DELETE_ACTIVITY_DETAILS,
  FETCH_ACTIVITY_DETAILS_SUCCESS,
  fetch_activity_dashboard_data_success,
  LOAD_ACTIVITY_SUMMARY_DETAILS_SUCCESS,
  fetch_activity_types_data_success,
  update_activity_pending_item_success
} from '../action/activity.action'
import { ActivityDashboardModel } from 'src/app/models/model'

export function activityReducer(state: ActivityState, action: Action) {
  return _activityReducer(state, action)
}

const _activityReducer = createReducer(
  initialActivityState,
  on(fetch_activity_dashboard_data_success, (state, { activityPendingItemsList, statusCountMap }) => {
    const dashboardData: ActivityDashboardModel = {
      activityPendingItemsList,
      statusCountMap
    }
    return {
      ...state,
      dashboard: dashboardData
    }
  }),
  on(FETCH_ACTIVITY_DETAILS_SUCCESS, (state, { activity }) => {
    return {
      ...state,
      details: activity
    }
  }),
  on(DELETE_ACTIVITY_DETAILS, (state, {}) => {
    return {
      ...state,
      details: null
    }
  }),
  on(LOAD_ACTIVITY_SUMMARY_DETAILS_SUCCESS, (state, data) => {
    return {
      ...state,
      summary: data
    }
  }),
  on(fetch_activity_types_data_success, (state, data) => {
    return {
      ...state,
      types: data.types
    }
  }),
  on(update_activity_pending_item_success, (state, data) => {
    return {
      ...state,
      isPendingActivitesUpdated: true
    }
  })
)
